var _circle, _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIftmLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 250,
    height: 250,
    viewBox: "0 0 250 250",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img",
    "aria-labelledby": titleId,
    ref: svgRef
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId || "title"
  }, "Logotipo do IFTM") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId || "title"
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 35,
    cy: 35,
    r: 35,
    fill: "#C11F27"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 90,
    width: 70,
    height: 70,
    rx: 12,
    fill: "#2EA84A"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 180,
    width: 70,
    height: 70,
    rx: 12,
    fill: "#2EA84A"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    y: 90,
    width: 70,
    height: 70,
    rx: 12,
    fill: "#2EA84A"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 90,
    y: 90,
    width: 70,
    height: 70,
    rx: 12,
    fill: "#2EA84A"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 180,
    y: 90,
    width: 70,
    height: 70,
    rx: 12,
    fill: "#2EA84A"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    y: 180,
    width: 70,
    height: 70,
    rx: 12,
    fill: "#2EA84A"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 90,
    y: 180,
    width: 70,
    height: 70,
    rx: 12,
    fill: "#2EA84A"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 180,
    y: 180,
    width: 70,
    height: 70,
    rx: 12,
    fill: "#2EA84A"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIftmLogo);
export default __webpack_public_path__ + "static/media/iftm-logo.681f4949059e6e033257c97a7bef791d.svg";
export { ForwardRef as ReactComponent };